import React, { FC, useState, useEffect } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

const StyledCookieBanner = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.blue};
  z-index: 1000;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  p {
    margin: 0 1rem 0 0;
    font-size: 14px;
    color: #fff;
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
  button {
    min-width: 2rem;
    min-height: 2rem;
    padding: 0;
    margin: 0;
    border-radius: 100%;
    background-color: #fff;
    cursor: pointer;
  }
  .cookie-banner-container {
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
  }
  @media screen and (min-width: 600px) {
    p {
      font-size: 16px;
    }
  }
`

const CookieBanner: FC = () => {
  const [cookiePolicyAcknowledged, setCookiePolicyAcknowledged] = useState(true)
  const acknowledgeCookiePolicy = () => {
    setCookiePolicyAcknowledged(true)
    localStorage.setItem("cookiePolicyAcknowledged", "true")
  }

  useEffect(() => {
    if (localStorage.getItem("cookiePolicyAcknowledged") !== "true") {
      setCookiePolicyAcknowledged(false)
    }
  }, [])
  return !cookiePolicyAcknowledged ? (
    <StyledCookieBanner>
      <div className="cookie-banner-container">
        <p>
          Cookies help us give you the best possible experience online. Read our{" "}
          <Link to="/privacy">cookie policy.</Link>
        </p>
        <button
          aria-label="Accept Cookie Policy"
          onClick={acknowledgeCookiePolicy}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </StyledCookieBanner>
  ) : null
}

export default CookieBanner
